const emojis = ["😞", "😔", "😐", "😊", "😄"];

const getEmoji = (value) => {
  return emojis[value - 1];
};

export default getEmoji;
